export function breakpoint() {
    return window.getComputedStyle
        ? window.getComputedStyle(document.body, ':after').getPropertyValue('content')
            .replace(/[^a-z-]/g, '')
        : null
    ;
}
